module.exports = __webpack_public_path__ + "static/img/sign-box.65f82c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sign-box.png
// module id = oBdo
// module chunks = 1